import { createStore } from '@stencil/store';
import { getDefaultDomains } from '@ugc-utils/domains';
import { defaultProduct } from '@ugc-utils/product';
import { defaultActionPermission } from '@ugc-containers/ugc-action-permission/interfaces';
import qnaState from './qna';
import reviewState from './review';
import reportAbuseState from './report-abuse';
import storeReviewState from './store-review';
import switchLanguage from './switch-language';

export const store = createStore({
  isLogin: false,
  isDesktop: true,
  toastInfo: [],
  isShowPerimeterx: false,
  isShowShareModal: false,
  isLitePdp: false,
  isEnableTagsV2: false,
  isEnableSummary: false,
  featureImpactType: 0,
  preference: {
    country: 'US',
    language: 'en-US',
    currency: 'USD',
  },
  domains: getDefaultDomains(),
  productInfo: defaultProduct,
  actionPermission: defaultActionPermission,
  shareUrl: '',
  visitorId: '',
  ...reportAbuseState,
  ...qnaState,
  ...reviewState,
  ...storeReviewState,
  ...switchLanguage,
});

const { state } = store;

export default state;
